import React from 'react'

const NavCard = ({ image, children, buttonLink, buttonText }) => (
    <div className="nav-card">
        {image && <img src={image} loading="lazy" />}
        <div>{children}</div>
        <a href={buttonLink} className="button button-large" target="_blank">{buttonText}</a>
    </div>
)

export default NavCard